import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { UpdateAllMarks } from "../../../Redux/Reducers/Manager/Marks";
import InputAHSF from "../../../Components/InputAHSF";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { GetQuestionSelectableTagsList } from "../../../Redux/Reducers/Manager/Dropdowns/QuestionSelectableTagsList";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";

function Marks(props) {
  const dispatch = useDispatch();
  const [dataJsonObject, SetDataJsonObject] = useState();
  const userRole = useSelector((state) =>
    state.RoleByUserGuid?.RoleByUserGuid?.map((ele) => ele?.rolesId)
  );
  const QuestionSelectableTagsList = useSelector(
    (state) => state.QuestionSelectableTagsList.QuestionSelectableTagsList
  );
  const [dataTotal, setDataTotal] = useState([]);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);

  // useEffect(() => {
  //   dataJson();
  // }, []);
  const state = useSelector((state) => {
    return {
      MarksManager: state?.MarksManager?.MarksManager,
      MarksManagerUpdate: state?.MarksManager?.MarksManagerUpdate,

      refreshTableStatus: state.refreshTableStatus.refreshTable,
    };
  });

  const [MarksList, setMarksList] = useState(state?.YesNoBySubTask);

  const [data, setData] = useState([]);
  const [loding, setLoding] = useState(false);

  // useEffect(() => {
  //   setMarksList(state?.MarksManager);
  // }, [state?.MarksManager]);

  const getData = () => {
    if (jsonData.domainUrl)
      axios
        .post(`${jsonData.domainUrl}/api/Marks/GetAllMarksBySubTaskGuid`, {
          subTaskId: props.taskId,
          mainTaskId: null,
        })
        .then((result) => {
          const data = result.data.result;
          setDataTotal(data);
          const yesNoList = {};
          data.forEach((marks) => {
            if (!yesNoList[marks.questionGroupName]) {
              yesNoList[marks.questionGroupName] = {
                GroupingName: "",
                row: "",
                value: [],
              };
            }
            yesNoList[marks.questionGroupName].GroupingName =
              marks.questionGroupName;
            yesNoList[marks.questionGroupName].row = marks.questionOrder;
            yesNoList[marks.questionGroupName].value.push(marks);
          });

          setData(yesNoList);
          setLoding(true);
        });
  };

  useEffect(() => {
    getData();
    dispatch(GetQuestionSelectableTagsList());
  }, []);

  // const UpdateData = (obj) => {
  //   console.log(obj, "objobj");

  //   dispatch(
  //     UpdateAllMarks({
  //       eV_NT_MarksEvaluationModel: obj,
  //     })
  //   );
  // };
  console.log(data, "userRoleuserRole");

  useEffect(() => {
    if (props.onDataChange) {
      props.onDataChange(data);
    }
  }, [data]);

  // useEffect(() => {
  //   dispatch(setRefreshTable());
  // }, [state.MarksManagerUpdate]);

  return (
    <>
      {data && data && userRole ? (
        <>
          {Object.keys(data).map((ele, index) => {
            return (
              <>
                <SharedDiv
                  showTitle={true}
                  titleName={userRole?.includes(
                    "d9aa628b-c8ec-487b-8796-1293b942207a"
                  ) ||
                    userRole?.includes(
                      "73c6d8f8-0796-4eeb-a788-383e5f63f8aa"
                    ) ? data[ele].GroupingName
                    : data[ele].GroupingName.includes("-")
                      ? data[ele].GroupingName.split("-")[0].trim() : data[ele].GroupingName}
                  child={[
                    <div className="table-container">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>معايير التقييم</th>
                            <th>العلامة </th>

                            <th>الشرح</th>
                            {userRole?.includes(
                              "d9aa628b-c8ec-487b-8796-1293b942207a"
                            ) ||
                              userRole?.includes(
                                "73c6d8f8-0796-4eeb-a788-383e5f63f8aa"
                              ) ? (
                              <>
                                <th>الوزن</th>
                                <th>المجموع</th>
                              </>
                            ) : (
                              <></>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data[ele]?.value.map((item, index) => {
                            console.log(item, "item");
                            console.log(ele);

                            return (
                              <tr key={index}>
                                <td>{item.questionName}</td>
                                <td>
                                  {props.disabled ?
                                    <InputAHSF
                                      fieldsName="Marks"
                                      type="number"
                                      hidelable={true}
                                      show={true}
                                      disabled={props.disabled}
                                      defaultValue={item.evalMark}
                                      style={{ width: "100%" }}

                                    /> :
                                    <AllDropDownsAHSF
                                      fieldsName="Marks"
                                      hidelable={true}
                                      // lang={lang}
                                      addPercent={true}
                                      show={true}
                                      disabled={props.disabled}
                                      dropdownType="normal"
                                      arrayOoptionList={QuestionSelectableTagsList}
                                      KeyText={"tags"}
                                      KeyValue={"tags"}
                                      defaultValue={item?.evalMark}
                                      // KeyValue={"eV_ST_QuestionSelectableTagsId"}
                                      value={item?.evalMark}
                                      onChange={(e) =>
                                        item.evalMark = e.target.value



                                      }
                                    />}
                                  {/* <InputAHSF
                                    fieldsName="Marks"
                                    type="number"
                                    show={true}
                                    MaxNumber={true}
                                    hidelable={true}
                                    disabled={props.disabled}
                                    defaultValue={item.evalMark}
                                    style={{ width: "100%" }}
                                    onChange={(e) => {
                                      item.evalMark = e.target.value;

                                      // UpdateData(data[ele]?.value);
                                    }}
                                  /> */}
                                </td>

                                <td id="ddsdsds">
                                  <textarea
                                    className="textarea-field"
                                    disabled={props.disabled}
                                    // placeholder="اكتب التوضيح هنا..."
                                    defaultValue={item.evalReason}
                                    onChange={(e) => {
                                      item.evalReason = e.target.value;
                                      // UpdateData(data[ele]?.value);
                                    }}
                                  />
                                </td>
                                {userRole?.includes(
                                  "d9aa628b-c8ec-487b-8796-1293b942207a"
                                ) ||
                                  userRole?.includes(
                                    "73c6d8f8-0796-4eeb-a788-383e5f63f8aa"
                                  ) ? (
                                  <>
                                    <td>
                                      <InputAHSF
                                        fieldsName="Marks"
                                        type="number"
                                        show={true}
                                        MaxNumber={true}
                                        hidelable={true}
                                        disabled={true}
                                        defaultValue={item.questionWeight}
                                        style={{ width: "100%" }}
                                        onChange={(e) => {
                                          // item.evalMark = e.target.value;
                                          // UpdateData(data[ele]?.value);
                                        }}
                                      />
                                    </td>

                                    {/* <td>{item.questionWeight}</td> */}
                                    <td>
                                      <InputAHSF
                                        fieldsName="Marks"
                                        type="number"
                                        show={true}
                                        MaxNumber={true}
                                        hidelable={true}
                                        disabled={true}
                                        defaultValue={item.total}
                                        style={{ width: "100%" }}
                                        onChange={(e) => {
                                          // item.evalMark = e.target.value;
                                          // UpdateData(data[ele]?.value);
                                        }}
                                      />
                                    </td>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      {userRole?.includes(
                        "d9aa628b-c8ec-487b-8796-1293b942207a"
                      ) || userRole?.includes(
                        "73c6d8f8-0796-4eeb-a788-383e5f63f8aa"
                      ) ? (
                        <>
                          {Object.keys(data).length - 1 == index ? (
                            <>
                              <div className="totalOfTotal">
                                <div className="labell">
                                  المجموع الكلي للعلامات
                                </div>
                                <div className="valuee">
                                  {dataTotal?.reduce(
                                    (acc, item) => acc + (item.total || 0),
                                    0
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>,
                  ]}
                />
              </>
            );
          })}
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default Marks;
